import { DataSourceCore } from './dataSourceCore'

export const DataSourceModule = {
  config(Vue, options) {
    Vue.$dataSourceCore = Vue.prototype.$dataSourceCore = new DataSourceCore(options.store, options.dataSources)
  }
}